import styled from 'styled-components';

export const LoaderWrapper = styled.div`
  position: fixed;
  width: 100%;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 10001;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 1);
  transition: display 0s linear 0.33s, opacity 0.33s linear;
`;
export const Loader = styled.img`
  width: 150px;
  height: 150px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
